module.exports = __webpack_public_path__ + "img/Group 1421.fd6b3de5.png";